// extracted by mini-css-extract-plugin
module.exports = {"content":"Content_content__3FZEj","breadcrumb":"Content_breadcrumb__182Hq"};